import { Icon } from './Icon';

interface Props {
  onBuildWithAI: () => void;
  onLoadTemplate: () => void;
  onAddTrigger: () => void;
}

export function EmptyCanvas({ onBuildWithAI, onLoadTemplate, onAddTrigger }: Props) {
  return (
    <div className="empty-canvas">
      <div className="empty-glow" aria-hidden="true" />
      <div className="empty-content">
        <div className="empty-hero">
          <span className="empty-orb"><Icon name="sparkle" size={28} variant="gold" /></span>
        </div>

        <h2>Let's build a workflow.</h2>
        <p>Pick any of these to get started — or just right-click the canvas to add blocks.</p>

        <div className="empty-actions">
          <button className="empty-action primary" onClick={onBuildWithAI}>
            <span className="empty-action-ic"><Icon name="sparkle" size={20} variant="gold" /></span>
            <div>
              <b>Build with AI</b>
              <span>Describe it in plain English</span>
            </div>
            <Icon name="arrowRight" size={14} variant="silver" />
          </button>

          <button className="empty-action" onClick={onLoadTemplate}>
            <span className="empty-action-ic"><Icon name="star" size={18} variant="silver" /></span>
            <div>
              <b>Load a starter template</b>
              <span>Storm reactivation · Missed-call · Payment</span>
            </div>
            <Icon name="arrowRight" size={14} variant="silver" />
          </button>

          <button className="empty-action" onClick={onAddTrigger}>
            <span className="empty-action-ic"><Icon name="lightning" size={18} variant="blue" /></span>
            <div>
              <b>Drop a Trigger block</b>
              <span>Start from scratch</span>
            </div>
            <Icon name="arrowRight" size={14} variant="silver" />
          </button>
        </div>

        <div className="empty-hint">
          <Icon name="help" size={11} variant="silver" />
          Need help? Press <code>?</code> for keyboard shortcuts.
        </div>
      </div>
    </div>
  );
}
